
      // Capture global errors and failed imports
      window.__ENTRY_ERROR__ = null;
      window.addEventListener('error', (e) => {
        const err = e?.error || e;
        window.__ENTRY_ERROR__ = (err && (err.stack || err.message)) || String(err);
      });
      window.addEventListener('unhandledrejection', (e) => {
        const reason = e?.reason;
        window.__ENTRY_ERROR__ = (reason && (reason.stack || reason.message)) || String(reason);
      });
      
      (async function() {
        try {
          const mod = await import('/src/main.tsx');
          console.log('[ENTRY] main.tsx imported', mod);
        } catch (e) {
          console.error('[ENTRY] Failed to import main.tsx', e);
          window.__ENTRY_ERROR__ = (e && (e.stack || e.message)) || String(e);
        }
      })();
    